import type { StyleConfig } from "@chakra-ui/theme-tools"

export const Progress: StyleConfig = {
  baseStyle: {
    track: {
      borderRadius: "lg",
    },
  },
  sizes: { sm: { track: { h: "0.625rem", bg: "main.100" } } },
  defaultProps: {
    size: "sm",
    colorScheme: "primary",
  },
}
